import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import _ from 'lodash';
import { Symbols } from '@/symbols';
let GlobalViewService = class GlobalViewService {
    constructor(globalViewApi, systemService, i18n) {
        this.globalViewApi = globalViewApi;
        this.systemService = systemService;
        this.i18n = i18n;
        this.getGlobalViewCompanyList = this.globalViewApi.getGlobalViewCompanyList;
        this.getGlobalViewFields = this.globalViewApi.getGlobalViewFields;
        this.putGlobalViewFields = this.globalViewApi.putGlobalViewFields;
        this.getGlobalViewUpdateTime = this.globalViewApi.getGlobalViewUpdateTime;
        this.fieldListKey = 'global_view_list';
    }
    getFiledSettingColumns(GlobalViewColumns) {
        return this.getGlobalViewFields(this.fieldListKey).then((res) => {
            let baseColumns = GlobalViewColumns;
            if (res.config_value) {
                const settingColumns = JSON.parse(res.config_value);
                // 如果设置的列数和默认列数一样，就按照设置的顺序排序
                if (settingColumns.length === baseColumns.length) {
                    baseColumns = _.sortBy(baseColumns, column => _.indexOf(settingColumns.map(col => col.field), column.field));
                }
                // 同步checked状态
                _.forEach(baseColumns, i => {
                    const column = _.find(settingColumns, col => col.field === i.field);
                    i.checked = column ? column.checked || false : true;
                });
                return baseColumns;
            }
            return baseColumns;
        });
    }
    getGlobalViewBaseColumns() {
        return [
            {
                label: this.i18n.t('backoffice.globalView.search.accountName'),
                field: 'company_name',
                checked: true,
                fixed: true,
                sortable: false,
                width: 280,
            },
            {
                label: this.i18n.t('backoffice.company.opportunity_risk'),
                field: 'company_tag_content',
                checked: true,
                fixed: false,
                sortable: false,
                width: 340,
            },
            ...!this.systemService.IsCn
                ? [{
                        label: this.i18n.t('backoffice.company.account_tier'),
                        field: 'account_tier',
                        checked: true,
                        fixed: false,
                        sortable: false,
                        width: 160,
                    }]
                : [],
            {
                label: this.i18n.t('backoffice.globalView.search.rating'),
                field: 'rating_v2_global',
                checked: true,
                fixed: false,
                sortable: false,
                width: 160,
            },
            ...!this.systemService.IsCn
                ? [{
                        label: this.i18n.t('backoffice.globalView.search.company_rank'),
                        field: 'company_rank',
                        checked: true,
                        fixed: false,
                        sortable: true,
                        width: 200,
                    }]
                : [],
            {
                label: this.i18n.t('backoffice.globalView.accountType'),
                field: 'account_type',
                checked: true,
                fixed: false,
                sortable: false,
                width: 200,
            },
            {
                label: this.i18n.t('backoffice.company.product'),
                field: 'main_product',
                checked: true,
                fixed: false,
                sortable: false,
                width: 200,
            },
            {
                label: this.i18n.t('backoffice.account.country'),
                field: 'billing_country',
                checked: true,
                fixed: false,
                sortable: false,
                width: 200,
            },
            ...!this.systemService.IsCn
                ? [{
                        label: this.i18n.t('backoffice.globalView.search.linkedinIndustry'),
                        field: 'linkedin_industry',
                        checked: true,
                        fixed: false,
                        sortable: false,
                        width: 200,
                    }]
                : [],
            {
                label: this.i18n.t('backoffice.globalView.search.verticals'),
                field: 'patsnap_vertical',
                checked: true,
                fixed: false,
                sortable: false,
                width: 200,
            },
            {
                label: this.i18n.t('backoffice.globalView.search.accountOwner'),
                field: 'account_owner',
                checked: true,
                fixed: false,
                sortable: false,
                width: 200,
            },
            ...!this.systemService.IsCn
                ? [{
                        label: this.i18n.t('backoffice.globalView.search.bdOwner'),
                        field: 'bd_owner',
                        checked: true,
                        fixed: false,
                        sortable: false,
                        width: 240,
                    }]
                : [],
            {
                label: this.i18n.t('backoffice.company.cur_year_acv'),
                field: 'cur_year_acv',
                checked: true,
                fixed: false,
                sortable: false,
                width: 240,
            },
            {
                label: this.i18n.t('backoffice.company.last_year_acv'),
                field: 'last_year_acv',
                checked: true,
                fixed: false,
                sortable: false,
                width: 240,
            }, {
                label: this.i18n.t('backoffice.common.action'),
                field: 'action',
                checked: true,
                fixed: true,
                sortable: false,
                width: 200,
                tdClass: 'right',
            }
        ];
    }
    get globalViewColumns() {
        return this.getGlobalViewBaseColumns();
    }
};
GlobalViewService = __decorate([
    injectable(),
    __param(0, inject(Symbols.GlobalViewApi)),
    __param(1, inject(Symbols.SystemService)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], GlobalViewService);
export { GlobalViewService };
